import { type BasicTaskHandlerSchema } from 'modules/procurement/components/procurementTypes/Workflows/sidePanels/schemas/basicTaskHandler'
import { HandlerFormComponentPayload } from 'modules/workflows/contexts/WorkflowContext'
import { DEFAULT_DURATION_UNIT, isValidDateUnit } from 'modules/workflows/lib/durationUnit'

export const basicTaskApproveNodeToSchemaMapper = (
  payload: HandlerFormComponentPayload
): BasicTaskHandlerSchema['nodeData']['payload'] => {
  const assignee_ids = payload.assignee_ids
  const due_on_unit = String(payload.due_on_unit)
  return {
    category: 'finance',
    due_on_unit: isValidDateUnit(due_on_unit) ? due_on_unit : DEFAULT_DURATION_UNIT,
    due_on_value: Number(payload.due_on_value),
    assignee_ids: Array.isArray(assignee_ids)
      ? assignee_ids.map((assignee_id) => Number(assignee_id))
      : [],
    title: String(payload.title ?? ''),
    description: String(payload.description ?? ''),
  }
}
